import { init as initFullStory, FullStory as FS } from '@fullstory/browser';

class FullstoryAdapter {
  constructor() {
    this._fullstory = FS;
    this.sessionIsActivated = false;
    this.devMode = true;
  }

  getClient() {
    return this._fullstory;
  }

  init(fullstoryOrgId) {
    if (fullstoryOrgId) {
      this.devMode = false;
      initFullStory({ orgId: fullstoryOrgId, startCaptureManually: true });
    }
  }

  activate() {
    if (!this.devMode && !this.sessionIsActivated) {
      this.sessionIsActivated = true;
      this._fullstory('start');
      this._fullstory('trackEvent', {
        name: 'Start Session',
      });
    }
  }

  deactivate() {
    if (!this.devMode && this.sessionIsActivated) {
      this._fullstory('trackEvent', {
        name: 'Shutdown Session',
      });
      this._fullstory('setIdentity', { anonymous: true });
      this._fullstory('shutdown');
      this.sessionIsActivated = false;
    }
  }

  reactivate() {
    if (!this.devMode && !this.sessionIsActivated) {
      this._fullstory('restart');
      this._fullstory('trackEvent', {
        name: 'Restart Session',
      });
      this.sessionIsActivated = true;
    }
  }
}

const fullstory = new FullstoryAdapter();
export default fullstory;
